export interface BucketDoc {
  name: string;
  keywords: string[];
  sub_bucket?: string;
}

export interface BucketRow {
  id: string;
  name: string;
  sub_bucket: string;
  keywords: string[];
}

export interface FirstStpBucketConfigResponse {
  buckets?: BucketDoc[];
  // Sibling fields on the same doc (logic blocks, platforms, etc.) are untouched.
}

export const rowSignature = (row: BucketRow): string =>
  JSON.stringify({
    name: row.name.trim().toLowerCase(),
    sub_bucket: (row.sub_bucket || "").trim().toLowerCase(),
    keywords: [...row.keywords],
  });

export const toBucketDoc = (row: BucketRow): BucketDoc => {
  const doc: BucketDoc = {
    name: row.name.trim(),
    keywords: row.keywords.map((k) => k.trim()).filter((k) => k.length > 0),
  };
  const trimmedSub = row.sub_bucket.trim();
  if (trimmedSub) doc.sub_bucket = trimmedSub;
  return doc;
};
